module.exports = __webpack_public_path__ + "img/l-hd.599983d9.webp";